const initialState = {
  yards: {
    data: [
      {
        id: 1,
        yardName: "Yard-1",
        location: "Kottakkal",
        stocks: [
          { id: 1, itemName: "TMT Bar", price: 5000, count: 10 },
          { id: 2, itemName: "Steel Bar", price: 2500, count: 10 },
          { id: 3, itemName: "Cement", price: 3500, count: 10 },
          { id: 4, itemName: "Sand", price: 1500, count: 10 },
          { id: 5, itemName: "M-Sand", price: 8000, count: 10 },
        ],
      },
      {
        id: 2,
        yardName: "Yard-2",
        location: "Valanchery",
        stocks: [
          { id: 1, itemName: "TMT Bar", price: 5000, count: 10 },
          { id: 2, itemName: "Steel Bar", price: 2500, count: 10 },
          { id: 3, itemName: "Cement", price: 3500, count: 10 },
          { id: 4, itemName: "Sand", price: 1500, count: 10 },
          { id: 5, itemName: "M-Sand", price: 8000, count: 10 },
        ],
      },
      {
        id: 3,
        yardName: "Yard-3",
        location: "Malappuram",
        stocks: [
          { id: 1, itemName: "TMT Bar", price: 5000, count: 10 },
          { id: 2, itemName: "Steel Bar", price: 2500, count: 10 },
          { id: 3, itemName: "Cement", price: 3500, count: 10 },
          { id: 4, itemName: "Sand", price: 1500, count: 10 },
          { id: 5, itemName: "M-Sand", price: 8000, count: 10 },
        ],
      },
      {
        id: 4,
        yardName: "Yard-4",
        location: "Kozhikkod",
        stocks: [
          { id: 1, itemName: "TMT Bar", price: 5000, count: 10 },
          { id: 2, itemName: "Steel Bar", price: 2500, count: 10 },
          { id: 3, itemName: "Cement", price: 3500, count: 10 },
          { id: 4, itemName: "Sand", price: 1500, count: 10 },
          { id: 5, itemName: "M-Sand", price: 8000, count: 10 },
        ],
      },
      {
        id: 5,
        yardName: "Yard-5",
        location: "Kochi",
        stocks: [
          { id: 1, itemName: "TMT Bar", price: 5000, count: 10 },
          { id: 2, itemName: "Steel Bar", price: 2500, count: 10 },
          { id: 3, itemName: "Cement", price: 3500, count: 10 },
          { id: 4, itemName: "Sand", price: 1500, count: 10 },
          { id: 5, itemName: "M-Sand", price: 8000, count: 10 },
        ],
      },
    ],
  },
};

export const yard_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_YARDS":
      return {
        ...state,
        yards: action.payload,
      };
    case "ADD_YARD":
      return {
        ...state,
        yards: [...state.yards, action.payload],
      };
    default:
      return state;
  }
};
